import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(@Inject(LOCALE_ID) public locale: string) {
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let url = request.url;
    if (url.includes('?')) {
      url = `${url}&hl=${this.locale}`
    } else {
      url = `${url}?hl=${this.locale}`
    }
    request = request.clone({url})
    return next.handle(request);
  }
}
